import React from "react";
import { useSnackbar } from "notistack";

import "./PremiumOpenBets.scss";
import { setTextColor } from "../../store/auth/authActions";

type StoreProps = {
  openBets: any[];
  eventName: string;
};

const PremiumOpenBets: React.FC<StoreProps> = ({
  openBets,
  eventName,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const calculateProfit = (bet: any) => {
    const odds = Number(bet?.oddValue ?? 0);
    const stake = Number(bet?.stakeAmount ?? 0);

    return (odds * stake - stake).toFixed(2);
  };

  return (
    <>
      {/* ================= MOBILE / TABLE VIEW ================= */}

      <div className="bet-mobile">
        <h3
          id="txnHeader"
          className={setTextColor(
            getComputedStyle(document.body).getPropertyValue(
              "--table-head"
            )
          )}
        >
          {eventName}
        </h3>

        <table>
          <thead>
            <tr id="header_back" className="tbl-tr">
              <th>Back (Bet For)</th>
              <th>Odds</th>
              <th>Stake</th>
              <th>Profit</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody className="tbl-body">
            {openBets?.length > 0 ? (
              openBets.map((bet, idx) => (
                <tr
                  key={bet?.id ?? `open-bet-${idx}`}
                  className="tbl-tr"
                >
                  <td>
                    {bet?.marketName} {" / "}
                    {bet?.runnerName}
                  </td>

                  <td>
                    {Number(
                      bet?.oddValue ?? 0
                    ).toFixed(2)}
                  </td>

                  <td>
                    {Number(
                      bet?.stakeAmount ?? 0
                    ).toFixed(2)}
                  </td>

                  <td>
                    {calculateProfit(bet)}
                  </td>

                  <td>
                    {bet?.betStatus}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>
                  There is no open bets
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ================= DESKTOP BET SLIP ================= */}

      <div className="bet-desk">
        <div
          id="matchSection"
          style={{ height: "calc(100% - 25px)" }}
        >
          <div
            id="openBetSelectionBox"
            className="slip-sort"
          >
            <select id="selectMenu">
              <option
                value={0}
                style={{ display: "block" }}
              >
                {eventName} - Match Odds
              </option>
            </select>
          </div>

          <div
            id="openBetSlip"
            className="bet_slip over-wrap"
            style={{ height: "calc(100% - 35px)" }}
          >
            <ul
              id="txnHead"
              className="slip-head"
            >
              <li className="col-bet">
                <strong>Matched</strong>
              </li>
            </ul>

            <div
              id="txnList"
              className="slip-list"
            >
              <ul
                id="backSlipHeader"
                className="matched-head"
              >
                <li className="col-bet">
                  Back (Bet For)
                </li>

                <li className="col-odd">
                  Odds
                </li>

                <li className="col-stake">
                  Stake
                </li>

                <li
                  className="col-profit"
                  style={{ textAlign: "center" }}
                >
                  Profit
                </li>

                <li className="col-status">
                  Status
                </li>
              </ul>

              {openBets?.length > 0 ? (
                openBets.map((bet, idx) => (
                  <dl
                    key={
                      bet?.id ??
                      `desktop-open-bet-${idx}`
                    }
                    id={`txn_${
                      bet?.id ?? idx
                    }`}
                    className="slip-back"
                    style={{ display: "block" }}
                  >
                    <dt>
                      <span
                        className="slip-type"
                      >
                        Back
                      </span>

                      <span className="short-amount">
                        {bet?.marketName} {" / "}
                        {bet?.runnerName}
                      </span>

                      <span className="marketName">
                        Match Odds
                      </span>
                    </dt>

                    <dd
                      className="col-odd"
                    >
                      {Number(
                        bet?.oddValue ?? 0
                      ).toFixed(2)}
                    </dd>

                    <dd
                      className="col-stake"
                      title="Stake"
                    >
                      {Number(
                        bet?.stakeAmount ?? 0
                      ).toFixed(2)}
                    </dd>

                    <dd
                      className="col-profit"
                    >
                      {calculateProfit(bet)}
                    </dd>

                    <dd
                      className="col-status"
                      title="Bet status"
                    >
                      {bet?.betStatus}
                    </dd>
                  </dl>
                ))
              ) : (
                <div>
                  There is no open bets
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PremiumOpenBets;